import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';

import { EquipmentModel } from '../models/equipment.model';

@Component({
  selector: 'ds-equipment-selection-item',
  templateUrl: './equipment-selection-item.component.html',
  styleUrls: ['./equipment-selection-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EquipmentSelectionItemComponent implements OnInit {
  @Input() optionItem: EquipmentModel;
  @Input() form: UntypedFormGroup;
  @Output() optionChangeEvent = new EventEmitter();

  optionCtrl: AbstractControl;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
  }

  toggleOption(option: string) {
    this.optionCtrl.setValue(option);
    this.optionItem.selectedOption = option;
    this.optionChangeEvent.emit(this.optionItem);
  }

  private buildForm() {
    this.form.addControl(
      this.optionItem.equipmentKey,
      new UntypedFormControl(
        'None',
        Validators.compose([Validators.compose([Validators.required])])
      )
    );
    this.optionCtrl = this.form.controls[this.optionItem.equipmentKey];
  }
}
